import { render, staticRenderFns } from "./ConfigureSamlSsoAuth.vue?vue&type=template&id=3ce2875a&scoped=true&"
import script from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js&"
export * from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureSamlSsoAuth.vue?vue&type=style&index=0&id=3ce2875a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce2875a",
  null
  
)

export default component.exports